import { i18n } from "./plugins/i18n";
var localisations = i18n[process.env.VUE_APP_LANGUAGE];

const processValue = (field, value) => {
    if (value === "Yes") {
        return true;
    } else if (value === "No") {
        return false;
    } else if (field.includes("-DateFrom")) {
        if (typeof value == "number") {
            return new Date(Date.UTC(value + 1, 0, 1));
        } else return value;
    } else if (field.includes("-DateTo")) {
        if (typeof value == "number") {
            return new Date(Date.UTC(value, 0, 1));
        } else {
            return value;
        }
    } else {
        return value;
    }
};

const processField = (field) => (field.includes("-") ? field.split("-")[0] : field);

const processOperator = (field) => {
    if (field.includes("-")) {
        let metaData = field.split("-")[1];
        if (metaData.includes("DateTo")) {
            return "<";
        } else if (metaData.includes("DateFrom")) {
            return ">=";
        } else {
            return "==";
        }
    } else {
        return "==";
    }
};

const isContextValid = (context) => context.id !== null && context.type !== null;

const clone = (objectsArray) => JSON.parse(JSON.stringify(objectsArray));

const calculateTopEightPropertiesList = (contextRootPropertiesList) => {
    if (contextRootPropertiesList.mrAttributeRowViewModelList.length == 0) return contextRootPropertiesList;

    const combined = {
        propertiesMaxPercent: 0,
        mrAttributeRowViewModelList: [],
    };

    combined.mrAttributeRowViewModelList = contextRootPropertiesList.mrAttributeRowViewModelList.slice(0, 8);
    let others = contextRootPropertiesList.mrAttributeRowViewModelList.slice(8);

    const othersCount = others.reduce((sum, current) => sum + current.count, 0);
    let otherPercent = others.reduce((sum, current) => sum + parseFloat(current.percent), 0).toPrecision(3);
    otherPercent = (otherPercent * 1).toString(); //to remove tailing zeros

    const otherVm = {
        name: localisations.OTHER,
        count: othersCount,
        percent: otherPercent,
    };
    combined.mrAttributeRowViewModelList.push(otherVm);
    combined.propertiesMaxPercent = Math.max(
        parseFloat(otherVm.percent),
        parseFloat(combined.mrAttributeRowViewModelList[0].percent),
    );

    return combined;
};

const combineRootPropertiesLists = (contextRootPropertiesList, nationalRootPropertiesList) => {
    // will contain combined context and national properties
    let combined = {
        propertiesMaxPercent: 0,
        mrAttributeRowViewModelList: [],
    };

    // at this step only context root properties
    // have information about properties that should be
    // displayed as "Other", save it
    let otherProperties = null;

    // will contain not merged national properties
    let nationalRootPropertiesListClone = clone(nationalRootPropertiesList.mrAttributeRowViewModelList);

    // looping through all context properties
    // merging every property with related record
    // from national properties
    contextRootPropertiesList.mrAttributeRowViewModelList.forEach(function (contextProperty) {
        // saving other properties for later use
        if (contextProperty.name === localisations.OTHER) {
            otherProperties = contextProperty;
            return;
        }
        nationalRootPropertiesListClone.forEach(function (nationalProperty, index, nationalPropertiesArr) {
            // related national property was found,
            // merging context and national property together
            // and pushing it to the combined array
            if (contextProperty.name.toLowerCase() === nationalProperty.name.toLowerCase()) {
                let temp = {
                    name: contextProperty.name,
                    count: contextProperty.count,
                    percent: contextProperty.percent,
                    nationalCount: nationalProperty.count,
                    nationalPercent: nationalProperty.percent,
                };

                combined.mrAttributeRowViewModelList.push(temp);
                // removing merged national property
                // from national properties array clone
                nationalPropertiesArr.splice(index, 1);
            }
        });
    });

    // other properties record was presented in context data,
    // and national data also has other properties,
    // combining them together
    if (otherProperties !== null) {
        // calculating not merged national properties sum and percentage
        otherProperties.nationalCount =
            nationalRootPropertiesListClone !== 0
                ? nationalRootPropertiesListClone.reduce((sum, current) => sum + current.count, 0)
                : 0;
        let otherPercent = nationalRootPropertiesListClone
            .reduce((sum, current) => sum + parseFloat(current.percent), 0)
            .toPrecision(3);			 
		otherProperties.nationalPercent = (otherPercent * 1).toString(); //to remove tailing zeros

        combined.mrAttributeRowViewModelList.push(otherProperties);
    }

    // searching max bar chart length in combined records
    combined.mrAttributeRowViewModelList.forEach(function (elem) {
        if (parseFloat(elem.percent) > parseFloat(combined.propertiesMaxPercent))
            combined.propertiesMaxPercent = elem.percent;
    });

    return combined;
};

const combineAndCommit = (commit, commitTo, stateData, nationalData) => {
    if (Object.entries(stateData).length !== 0 && stateData !== Object)
        if (stateData.mrAttributeRowViewModelList.length > 0) {
            commit(commitTo, combineRootPropertiesLists(stateData, nationalData));
        }
};

export {
    processOperator,
    processField,
    processValue,
    isContextValid,
    calculateTopEightPropertiesList,
    combineRootPropertiesLists,
    clone,
    combineAndCommit,
};
